// extracted by mini-css-extract-plugin
export default {"box":"fa24ea","box_padding":"e2bde4","boxPadding":"e2bde4","box__title":"d89917","boxTitle":"d89917"};